import React from 'react';
import { IonContent, IonPage } from '@ionic/react';

//	L O C A L E

import { locale___SbLandingPage } from './sb-landing.locale';

//	S T Y L E

import './sb-landing.scss';

//	S E R V I C E S

import { service_LocalizationService } from '../../services/service-localization';

//	C O M P O N E N T S

import ComSpinnerComponent from '../../components/com-spinners/com-spinner/com-spinner';

//	E X P O R T

export default class SbLandingPage extends React.Component<{}, {}> {

//#region 																							D E C L A R A T I O N S

	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<IonPage>
				<IonContent forceOverscroll={ false }>
					<section className="sb-landing---container">
						<div className="sb-landing---loader">
							<ComSpinnerComponent size="standard" theme="dark" />
						</div>
						<h3 className="sb-landing---loader---text">
							{ this._LOCALE.translate(locale___SbLandingPage.map_is_loading) }
						</h3>
					</section>
				</IonContent>
			</IonPage>
		</>
	}

//#endregion

}